/** @jsxImportSource @emotion/react */
import { useRouter } from 'next/router'
import { Button, Heading } from 'grommet'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { StatusGood, Link as LinkIcon } from 'grommet-icons'

import { plotUrl } from 'util/plot'
import { ExistingGroup, Group, MoodWithEmotion } from 'db-tables'
import useCopy from 'hooks/useCopy'

type Props = {
  group: Group | ExistingGroup
  moods?: MoodWithEmotion[]
  linkResults?: boolean
}
export default function GroupTitle({ group, linkResults = false }: Props) {
  const { copied, onCopy } = useCopy()
  const { locale } = useRouter()
  return (
    <Heading
      key={group.id}
      size="small"
      textAlign="center"
      margin={{ top: 'medium', bottom: 'xsmall' }}
      css={{ display: 'inline', alignItems: 'center', alignSelf: 'center' }}>
      {group?.name}
      <CopyToClipboard
        text={plotUrl({ shortCode: group.short_code, locale, showResults: linkResults })}
        onCopy={onCopy}>
        <Button
          plain
          size="small"
          css={{ display: 'inline' }}
          margin={{ left: '.5rem' }}
          icon={copied ? <StatusGood color="status-ok" size="18px" /> : <LinkIcon size="18px" />}
        />
      </CopyToClipboard>
    </Heading>
  )
}
